import { getStatusStats } from '@/apis/dashboard'

const state = {
    statusStats: {}
}

const mutations = {
    SET_STATUS_STATS: (state, statusStats) => {
        state.statusStats = statusStats
    },
    REMOVE_STATUS_STATS: (state) => {
        state.statusStats = {}
    },
}

const actions = {
    getStatusStats({ commit }) {
        return new Promise((resolve, reject) => {
            getStatusStats().then(res => {
                const { data } = res
                commit('SET_STATUS_STATS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}